import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Observer } from "rxjs";
import { FranchiseAppGlobal } from "../franchise-app-global";
import { AppConfigService } from "../shared/providers/config.service";
import { ForgotPasswordDto, GetUserEmailDto, ResetPasswordDto, SignInInputModel, SignInOutputModel, UserProfileDto } from "../admin/models/account-model";

@Injectable()
export class AccountServiceService {
  private env;
  constructor(public http: HttpClient, private config: AppConfigService) {
    this.env = this.config.getConfig();
  }

  // Admin login
  Login(signInInputDto: SignInInputModel): Observable<SignInOutputModel> {
    var object = JSON.stringify(signInInputDto);
    let url = this.env.baseUrl + FranchiseAppGlobal.adminLogin;
    return this.http.post<SignInOutputModel>(url, object);
  }

  Authenticate(signInInputDto: SignInInputModel): Observable<SignInOutputModel> {
    var object = JSON.stringify(signInInputDto);
    let url = this.env.baseUrl + FranchiseAppGlobal.adminAuthenticate;
    return this.http.post<SignInOutputModel>(url, object);
  }
  // Admin profile
  GetProfile(): Observable<UserProfileDto> {
    let url = this.env.baseUrl + FranchiseAppGlobal.adminGetProfile;
    return this.http.get<UserProfileDto>(url);
  }
  // Admin permissions
  GetPermissions(): Observable<string[]> {
    let url = this.env.baseUrl + FranchiseAppGlobal.adminGetPermissions;
    return this.http.get<string[]>(url);
  }
  // Admin logout
  Logout(): Observable<boolean> {
    let url = this.env.baseUrl + FranchiseAppGlobal.adminLogout;
    return this.http.get<boolean>(url);
  }
  GetChaptcha(key: string): Observable<any> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getCaptcha + "/" + key;
    return this.http.get(url, { responseType: "blob" });
  }

  GetUserEmail(id: string): Observable<GetUserEmailDto> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getUserEmail + id;
    return this.http.get<GetUserEmailDto>(url);
  }
  EmailActivation(id: string): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.emailActivation + id;
    return this.http.get<void>(url);
  }
  ForgotPassword(input: ForgotPasswordDto): Observable<void> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.forgotPassword;
    return this.http.put<void>(url, object);
  }
  ResetPassword(input: ResetPasswordDto): Observable<void> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.resetPassword;
    return this.http.put<void>(url, object);
  }
}
